import { Redirect, Route } from 'react-router-dom';

const ConditionalRedirectRoute = ({
  condition,
  component: Component,
  redirectPath,
  childProps,
  ...rest
}) => {
  const render = props => {
    if (condition) {
      return <Component {...props} {...childProps} />;
    }

    if (!!redirectPath) {
      return <Redirect to={redirectPath} />;
    }

    return null;
  };

  return <Route {...rest} render={render} />;
};

export default ConditionalRedirectRoute;
